export {default} from "./TextReveal";
